document.addEventListener("DOMContentLoaded", function() {
  const variantSelectors = document.querySelectorAll('select[name*="option"]');
  
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', updateProductImages);
  });

  function updateProductImages() {
    const selectedColor = document.querySelector('select[name*="option"]').value.toLowerCase();
    const allImages = document.querySelectorAll('.product-single__photo');

    allImages.forEach(image => {
      if (image.dataset.color === selectedColor) {
        image.style.display = 'block';  // 顯示該顏色的所有圖片
      } else {
        image.style.display = 'none';  // 隱藏其他圖片
      }
    });
  }

  updateProductImages(); // 初次載入時更新圖片
});
